module.exports = __webpack_public_path__ + "img/receive parcel (1).a1a90744.svg";